export const getWalletsData = (page) => ({
  method: "get",
  url: `wallets?page=${page}`,
})

export const getRedeemsData = (page) => ({
  method: "get",
  url: `wallets/redeems?page=${page}`,
})

export const createTransport = (data) => ({
  method: "post",
  url: `pricing/transportation/create`,
  config: {
    data
  }
})

export const getWalletByIdRequest = (id) => ({
  method: "get",
  url: `wallets/${id}/view`
})
export const deleteTransport = (id) => ({
  method: "delete",
  url: `pricing/transportation/${id}/delete`,
})

export const updateWallet = (id, data) => ({
  method: "post",
  url: `wallets/${id}/store`,
  config: {
    data
  }
})